module.exports = __webpack_public_path__ + "static/media/Didari.d692ec3e.svg";